import { SingleSelectFilter, onChangeFunc } from 'components/core/search-filter/singleSelectFilter'
import { getFilterKeyToLabelMap } from 'components/core/task/ContextualTaskSearchFilter'
import { periods } from 'components/core/time/duration/index'
import { Duration } from 'pbts/google/protobuf/duration'
import React from 'react'
import { useIntl } from 'react-intl'

export enum Ages {
    SEVEN_DAYS = periods.ONE_DAY * 7,
    FOURTEEN_DAYS = periods.ONE_DAY * 14,
    THIRTY_DAYS = periods.ONE_DAY * 30,
}

export const DurationToAge = (currentDuration: number): Ages | null => {
    switch (currentDuration) {
        case Ages.SEVEN_DAYS:
            return Ages.SEVEN_DAYS
        case Ages.FOURTEEN_DAYS:
            return Ages.FOURTEEN_DAYS
        case Ages.THIRTY_DAYS:
            return Ages.THIRTY_DAYS
        default:
            return null
    }
}

export const AgeToDuration = (age: Ages): Duration => {
    return Duration.create({ seconds: age })
}

type taskAgeFilterProps = {
    selected: Duration | undefined
    onChange: onChangeFunc<Duration | undefined>
}

export const TaskAgeFilter: React.FC<taskAgeFilterProps> = ({ selected, onChange }): React.ReactElement => {
    const intl = useIntl()
    const filterKeyToLabel = getFilterKeyToLabelMap(intl)

    const agesToString = (age: Ages): string => {
        switch (age) {
            case Ages.SEVEN_DAYS:
                return intl.formatMessage({
                    id: 'gt_seven_days',
                    defaultMessage: '7+ days',
                })
            case Ages.FOURTEEN_DAYS:
                return intl.formatMessage({
                    id: 'gt_fourteen_days',
                    defaultMessage: '14+ days',
                })
            case Ages.THIRTY_DAYS:
                return intl.formatMessage({
                    id: 'gt_thirty_days',
                    defaultMessage: '30+ days',
                })
            default:
                return intl.formatMessage({
                    id: 'unknown',
                    defaultMessage: 'Unknown',
                })
        }
    }

    const renderLabel = (option: Ages): string => {
        return agesToString(option)
    }

    const selectedDurationToAge = (duration: Duration | undefined): Ages | null => {
        return DurationToAge(duration?.seconds || 0)
    }

    const onChangeAge = (age: Ages | undefined, loading): void => {
        if (!age) {
            onChange(undefined, loading)
            return
        }
        onChange(AgeToDuration(age), loading)
    }

    return (
        <SingleSelectFilter<Ages>
            label={filterKeyToLabel['older-than'] || ''}
            options={[Ages.SEVEN_DAYS, Ages.FOURTEEN_DAYS, Ages.THIRTY_DAYS]}
            selected={selectedDurationToAge(selected)}
            onChange={(duration, loading): void => onChangeAge(duration, loading)}
            renderLabel={renderLabel}
        />
    )
}
